//#region [IMPORT]

// === THIRD-PARTY ==
import { useNavigate } from "react-router-dom";

// === API ===
import { prokeyApi } from "api/prokey";
import { sendMessageData } from "api/prokey/prokey.websocket";

//#endregion

//-----------------------------------------------------------------
export const useLogout = () => {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const navigate = useNavigate();

  //#endregion

  //#region [METHOD]

  async function logout() {
    try {
      // The HTTP logout clears the authentication cookies. Closing only the
      // websocket leaves the browser authenticated and protected routes open.
      await prokeyApi.logout();
      sendMessageData( 'LOGOUT' );
    } catch (error) {
      console.warn( error );
    } finally {
      navigate(`/login`, { replace: true } );
    }
  }

  //#endregion

  return logout;
};
